// extracted by mini-css-extract-plugin
module.exports = {"canvas":"_98d1fd92","isShadeDown":"_0c752f11"};